import Vue from 'vue'
import Vuex from 'vuex'

import module_about from './module/module_about'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        about: module_about,
    },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js